exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".exercise-sudoku .palace-list {\n  display: inline-block;\n  border: 4px solid #b6e0ff;\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  border-radius: 4px;\n}\n.exercise-sudoku .palace-list .palace-row {\n  display: block;\n  border-bottom: 2px solid #b6e0ff;\n}\n.exercise-sudoku .palace-list .palace-row:last-child {\n  border: 0;\n}\n.exercise-sudoku .palace-list .palace-item {\n  display: inline-block;\n  vertical-align: top;\n  width: 40px;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  color: #5d758b;\n  font-size: 18px;\n  border-right: 2px solid #b6e0ff;\n}\n.exercise-sudoku .palace-list .palace-item:last-child {\n  border: 0;\n}\n.exercise-sudoku .palace-list .palace-blank {\n  color: #5ebaff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"importLoaders":1}!./src/entry_question_editor/question/exercise/sudoku/index.less
// module id = 1146
// module chunks = 60 61 62